import { styled } from "@mui/material/styles";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";

export const Card = styled(Box)(({ theme }) => ({
  backgroundColor: "#1c1c1c",
  borderRadius: "20px",
  padding: "32px",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  border: `1px solid ${theme.palette.divider}`,
}));

export const DialogTitle = styled(Typography)(() => ({
  color: "#ffffff",
  fontWeight: 700,
  fontSize: "22px",
  lineHeight: 1.3,
}));

export const RatingRow = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: "12px",
  flexWrap: "wrap",
}));

export const RatingLabel = styled(Typography)(() => ({
  color: "#bdbdbd",
  fontSize: "0.875rem",
}));

type RatingButtonProps = { selected: boolean };

export const RatingButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "selected",
})<RatingButtonProps>(({ theme, selected }) => ({
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  fontSize: "16px",
  fontWeight: 600,
  color: selected ? "#000000" : "#ffffff",
  backgroundColor: selected ? theme.palette.primary.main : "#2b2b2b",
  border: selected
    ? `1px solid ${theme.palette.primary.main}`
    : "1px solid #3a3a3a",
  transition: "background-color 120ms ease, color 120ms ease",
  "&:hover": {
    backgroundColor: selected ? theme.palette.primary.main : "#383838",
  },
  "&.Mui-disabled": {
    color: selected ? "#000000" : "#777777",
    backgroundColor: selected ? theme.palette.primary.main : "#2b2b2b",
    opacity: 0.6,
  },
}));

export const CommentArea = styled(TextField)(() => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#f1f1f1",
    borderRadius: "12px",
    fontSize: "14px",
    color: "#000000",
    "& fieldset": { border: "none" },
    "&:hover fieldset": { border: "none" },
    "&.Mui-focused fieldset": { border: "none" },
  },
  "& .MuiInputBase-input::placeholder": {
    color: "#888888",
    opacity: 1,
  },
}));

export const DialogActionsRow = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  gap: "12px",
  marginTop: "8px",
}));

export const CancelButton = styled(Button)(() => ({
  backgroundColor: "transparent",
  color: "#ffffff",
  border: "1.5px solid #ffffff",
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "14px",
  padding: "8px 24px",
  minWidth: "110px",
  "&:hover": {
    backgroundColor: "rgba(255,255,255,0.08)",
    borderColor: "#ffffff",
  },
}));

export const ConfirmButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: "#000000",
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 700,
  fontSize: "14px",
  padding: "8px 24px",
  minWidth: "110px",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: theme.palette.primary.main,
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    backgroundColor: "#3a3a3a",
    color: "#777777",
  },
}));
